import $ from 'jquery';

$(function() {

    $.fn.tableZoom = function() {
        return $(this).each(function() {
            var table = $(this);
            var wrap = table.wrap("<div>").parent();
            wrap.addClass('table-zoom');
            var inner = $("<div>").addClass('table-zoom__inner').appendTo(wrap);
            inner.append(table);
            // wrap.on('mouseleave',function() {
            //     inner.animate({scrollLeft:0},200);
            // });
            wrap.on('mousemove',function(e) {

                var max = $(this).outerWidth();
                var x;
                if(e.type == "touchmove") {
                    var t = e.originalEvent.touches[0];
                    x = t.clientX;
                    //e.preventDefault();
                    //e.stopPropagation();
                } else {
                    x = e.clientX - $(this).offset().left;
                }

                inner.stop();
                if(x < 0)x = 0;
                if(x > max)x = max;
                var p = x / $(this).outerWidth();
                var diff = table.outerWidth() - $(this).outerWidth();
                if(diff <= 0) {
                    inner.scrollLeft(0);
                } else {
                    inner.scrollLeft(diff * p);
                }

            });

            var setScroll = function() {
                wrap.removeClass('has-scroll');
                if(table.outerWidth() > inner.outerWidth()) {
                    wrap.addClass('has-scroll');
                }
            }

            $(window).on('resize',setScroll);
            setScroll();
        });
    }

    $('table[data-zoom-table]').tableZoom();

    $('[data-table-trigger]').click(function(event) {
        var root = $(this).closest('.table');
        root.toggleClass('active');
        var content = root.find('.table__content');
        var inner = root.find('.table__content__inner');
        content.css('maxHeight',root.hasClass('active') ? inner.outerHeight() : '' );
    });

    $(window).on('resize',function(e) {
        $('.layout.table.active').each(function() {
            var content = $(this).find('.table__content');
            var inner = $(this).find('.table__content__inner');
            content.css('maxHeight',inner.outerHeight() );
        })
    }).trigger('resize');
})
